import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["size", "appearance", "iconLeft", "iconRight", "children", "shape"];
import cn from 'classnames';
import { createButton } from './hocs';
import { getLoaderSize } from './utils';
import styles from './button-mobile.module.css';
const useBaseButtonMobile = _ref => {
  let {
      size = 'l',
      appearance = 'primary',
      iconLeft,
      iconRight,
      children,
      shape
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const loaderSize = getLoaderSize(size);
  const onlyIcon = (iconLeft || iconRight) && !children;
  return _extends({}, restProps, {
    iconLeft,
    iconRight,
    children,
    className: cn(styles.root, styles[`shape_${shape}`], {
      [styles.onlyIcon]: onlyIcon
    }),
    textOverflow: 'fade',
    'data-size': size,
    'data-appearance': appearance,
    loaderSize
  });
};
export const ButtonMobile = createButton(useBaseButtonMobile);